<template>
  <v-layout row>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img
          src="/img/comingsoon.png"
          height="200px"
        >
        </v-img>
        <v-card-title primary-title>

        </v-card-title>

        <v-card-actions>

        </v-card-actions>

        <v-slide-y-transition>
          <v-card-text v-show="show">
            Temporalmente fuera de servicio.
          </v-card-text>
        </v-slide-y-transition>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data: () => ({
      show: false
    })
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/comingsoon.vue